import { createLayoutConverter } from './util/createLayoutConverter'

export default createLayoutConverter({
  leftWidth: 0.5,
  rightWidth: 0.5,
  label: 'twoColumn',
  identifier: 'TwoColumn',
})
